import { runAdditionalValidation } from "./additional-field-validation.js";
import { validateFields } from "./validation.js";
const getFieldErrors = async (fieldsToValidate, form, addressTemplates, externalData, validationMode) => {
  const formValues = fieldsToValidate.reduce(
    (acc, field) => setValue(acc, field.path, field.value),
    {}
  );
  const result = await validateFields(
    form,
    formValues,
    addressTemplates,
    validationMode
  );
  const _errors = result?.errors || [];
  const additionalErrors = runAdditionalValidation({
    form,
    values: formValues,
    externalData
  });
  const allErrors = mergeErrors({ errors: _errors, additionalErrors });
  const fieldErrors = allErrors.filter(
    (error) => findErrorByNormalizedPath(fieldsToValidate, error.errorPath)
  );
  return fieldErrors;
};
const findErrorByNormalizedPath = (fieldsToValidate, errorPath) => {
  return !!fieldsToValidate.find(
    (field) => errorPath === field.path || errorPath.startsWith(`${field.path}/`)
  );
};
function setValue(object, path, value) {
  const delimiter = "/";
  const decomposedPath = path.split(delimiter);
  const base = decomposedPath[0];
  if (base === void 0) {
    return object;
  }
  if (!object.hasOwnProperty(base)) {
    object[base] = {};
  }
  value = decomposedPath.length <= 1 ? value : setValue(object[base], decomposedPath.slice(1).join(delimiter), value);
  return {
    ...object,
    [base]: value
  };
}
const mergeErrors = ({
  errors,
  additionalErrors
}) => {
  const errorsToAdd = [];
  if (additionalErrors) {
    Object.keys(additionalErrors).forEach((fieldTarget) => {
      const errorExists = errors.find(
        (error) => error.errorPath === fieldTarget
      );
      if (!errorExists) {
        errorsToAdd.push(additionalErrors[fieldTarget]);
      }
    });
  }
  return [...errors, ...errorsToAdd];
};
export {
  findErrorByNormalizedPath,
  getFieldErrors,
  mergeErrors
};
//# sourceMappingURL=get-field-errors.js.map
